import { roles } from 'common/constants';
import _ from 'lodash';

export default function isSuperAdminOrganization(rootStore) {
	return (
	
		_.findIndex(
			rootStore.app.baasic.userHandler.user.user.roles,
			role => role === roles.scanshipSuperAdministrator
		) != -1
	);
}



// WEBPACK FOOTER //
// ./src/core/utils/isSuperAdminOrganization.js